module.exports = __webpack_public_path__ + "static/media/popup-background.1fa1f44c.svg";